import { Category } from '../services/categoryService';
import { Tour } from '../types';
import { optimizeImageUrl } from './optimizeImageUrl';

/**
 * Common logic to find the hero image for a category
 */
export const getHeroImageForCategory = (category: Category, allTours: Tour[]): string | null => {
  // Find tours for this category
  const categoryTours = allTours.filter(t => 
    t.categoryId === category.id || t.category?.toLowerCase() === category.name?.toLowerCase()
  );
  
  if (categoryTours.length === 0) return null;

  // Sort by sortOrder (ascending), then by createdAt (descending) 
  // matches applyFeaturedOrder logic
  const sortedTours = [...categoryTours].sort((a, b) => {
    const orderDiff = (a.sortOrder || 0) - (b.sortOrder || 0);
    if (orderDiff !== 0) return orderDiff;
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });
  
  const tourWithImage = sortedTours.find(t => t.images && t.images.length > 0);
  return tourWithImage?.images?.[0] || null;
};

/**
 * Standard optimization parameters for hero images
 * Using 2048px width as a consistent high-res source for both preload and display
 */
export const HERO_IMAGE_WIDTH = 2048;
export const HERO_IMAGE_QUALITY = 90;

export const getOptimizedHeroUrl = (rawUrl: string) => {
  return optimizeImageUrl(rawUrl, { width: HERO_IMAGE_WIDTH, quality: HERO_IMAGE_QUALITY });
};
